<template>
  <div id="genealogie">
    <v-container grid-list-md fluid>
      <v-layout row wrap class="main_layout_db">
        <v-flex d-flex xs12 md7 lg7>
          <v-card flat class="trbg genealogie-card">
            <h2>{{ translate['Genealogie der Familie Lachmann'][lang] }}</h2>
            <svg
              version="1.1"
              viewBox="-0.5 -0.5 907 2208.7786"
              id="genealogie-svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:svg="http://www.w3.org/2000/svg"
              xmlns:xhtml="http://www.w3.org/1999/xhtml"
            >
              <defs id="defs1" />
              <g id="g173" transform="matrix(0.7074883,0,0,0.7074883,0.2074883,0.2074883)">
                <g id="g171">
                  <g data-cell-id="0" id="g170">
                    <g data-cell-id="1" id="g169">
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-1" id="g4">
                        <g id="g1">
                          <rect
                            x="0"
                            y="0"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect1"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('dr-edmund-lachmann') }"
                            @click="showPerson('dr-edmund-lachmann')"
                          />
                        </g>
                        <g id="g3">
                          <g transform="scale(2)" id="g2">
                            <switch id="switch1">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 40px;
                                  margin-left: 1px;"
                                >
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000;"
                                  >
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal;"
                                    >
                                      <b>Dr. Edmund Lachmann<br /></b>
                                      Berlin, 31.12.1853 – Berlin, 28.3.1909</div>
                                  </div>
                                </div>
                              </foreignObject>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-2"
                        id="g8">
                        <g id="g5">
                          <rect
                            x="640"
                            y="0"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect4"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('rosalie-annette-lachmann') }"
                            @click="showPerson('rosalie-annette-lachmann')"
                          />
                        </g>
                        <g id="g7">
                          <g transform="scale(2)" id="g6">
                            <switch
                              id="switch5">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 40px;
                                  margin-left: 321px;"
                                >
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000;"
                                  >
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal;"
                                    >
                                      <b>Rosalie-Annette Lachmann</b>
                                      <div>geb. Eltzbacher<br />
                                      um 1864 – Berlin 1901</div>
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g
                        data-cell-id="fKRA-seUdEVxIebNOzLq-10"
                        id="g20">
                        <g
                          id="g9" />
                        <g
                          data-cell-id="fKRA-seUdEVxIebNOzLq-8"
                          id="g13">
                          <g
                            id="g10">
                            <rect
                              x="509.5"
                              y="0"
                              width="100"
                              height="160"
                              fill="none"
                              stroke="none"
                              pointer-events="all"
                              id="rect9"
                              class="person-rect"
                            />
                          </g>
                          <g
                            id="g12">
                            <g
                              transform="scale(2)"
                              id="g11">
                              <switch
                                id="switch10">
                                <foreignObject
                                  style="overflow: visible; text-align: left;"
                                  pointer-events="none"
                                  width="100%"
                                  height="100%"
                                  requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                  <div
                                    style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 48px; height: 1px; padding-top: 40px; margin-left: 256px;">
                                    <div
                                      style="box-sizing: border-box; font-size: 0; text-align: center; color: #000000; ">
                                      <div
                                        style="display: inline-block; font-size: 12px; font-family: Helvetica, Arial; color: light-dark(#000000, #ffffff); line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                                        <div
                                          style="line-height: 80%;">
                                          <br />
                                          <span style="font-family: Arial, Helvetica, sans-serif;">
                                            <font style="font-size: 10px; line-height: 80%;">20.09.1883<br />Amsterdam</font>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </foreignObject>
                                <text
                                  x="280"
                                  y="44"
                                  fill="light-dark(#000000, #ffffff)"
                                  font-family="Helvetica"
                                  font-size="12px"
                                  text-anchor="middle"
                                  id="text10">20.09.18...</text>
                              </switch>
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-7" id="g19">
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-5" id="g16">
                            <g id="g15">
                              <circle
                                cx="566"
                                cy="51"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse14"
                                r="13" />
                            </g>
                          </g>
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-6" id="g18">
                            <g id="g17">
                              <circle
                                cx="553"
                                cy="51"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse16"
                                r="13" />
                            </g>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-11" id="g22">
                        <g id="g21">
                          <path
                            d="M 80,240 H 560"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path20" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-17" id="g24">
                        <g id="g23">
                          <path
                            d="M 160,400 H 120 80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path22" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-14" id="g28">
                        <g id="g25">
                          <rect
                            x="160"
                            y="320"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect24"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('ernst-lachmann') }"
                            @click="showPerson('ernst-lachmann')"
                          />
                        </g>
                        <g id="g27">
                          <g transform="scale(2)" id="g26">
                            <switch
                              id="switch25">
                              <foreignObject
                                style="overflow: visible;
                                text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
                              >
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 200px;
                                  margin-left: 81px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; "
                                    >
                                      <b>Ernst Lachmann</b><br />
                                      Berlin, 7.11.1884 – Berlin, 17.1.1942
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="200"
                                y="204"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text25">Ernst Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-15" id="g32">
                        <g id="g29">
                          <rect
                            x="800"
                            y="320"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect28"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('giselle-lachmann') }"
                            @click="showPerson('giselle-lachmann')"
                          />
                        </g>
                        <g id="g31">
                          <g transform="scale(2)" id="g30">
                            <switch id="switch29">
                              <foreignObject
                                style="overflow: visible;
                                text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 200px;
                                  margin-left: 401px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <div><b>Giselle Lachmann</b><br />
                                      geb. Rabinerson<br />
                                      geb. Kiew, 4.12.1893</div>
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="520"
                                y="204"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text29">Giselle Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-16" id="g34">
                        <g id="g33">
                          <path
                            d="M 80,240 V 2480"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path32" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-18" id="g48">
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-19" id="g39">
                          <g
                            id="g36">
                            <rect
                              x="674"
                              y="320"
                              width="100"
                              height="160"
                              fill="none"
                              stroke="none"
                              pointer-events="all"
                              id="rect35" />
                          </g>
                          <g id="g38">
                            <g transform="scale(2)" id="g37">
                              <switch id="switch36">
                                <foreignObject
                                  style="overflow: visible; text-align: left;"
                                  pointer-events="none"
                                  width="100%"
                                  height="100%"
                                  requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                  <div
                                    style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 48px; height: 1px; padding-top: 200px; margin-left: 338px;">
                                    <div
                                      style="box-sizing: border-box; font-size: 0; text-align: center; color: #000000; ">
                                      <div
                                        style="display: inline-block; font-size: 12px; font-family: Helvetica; color: light-dark(#000000, #ffffff); line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                                        <div
                                          style="line-height: 80%;">
                                          <br />
                                          <span
                                            style="font-family: Arial, Helvetica, sans-serif;">
                                            <font style="font-size: 10px; line-height: 80%;">17.6.1919<br />
                                              Berlin</font>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </foreignObject>
                                <text
                                  x="362"
                                  y="204"
                                  fill="light-dark(#000000, #ffffff)"
                                  font-family="Helvetica"
                                  font-size="12px"
                                  text-anchor="middle"
                                  id="text36">17.6.191...</text>
                              </switch>
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-20" id="g45">
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-21" id="g42">
                            <g id="g41">
                              <circle
                                cx="730.5"
                                cy="371"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse40"
                                r="13" />
                            </g>
                          </g>
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-22" id="g44">
                            <g id="g43">
                              <circle
                                cx="717.5"
                                cy="371"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse42"
                                r="13" />
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-39" id="g47">
                          <g id="g46">
                            <path
                              d="m 680,480.34 h 80"
                              fill="none"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-miterlimit="10"
                              pointer-events="stroke"
                              id="path45" />
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-23" id="g50">
                        <g id="g49">
                          <path
                            d="m 560,240 -0.5,-80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path48" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-24" id="g52">
                        <g id="g51">
                          <path
                            d="M 240,560 H 720"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path50" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-26" id="g54">
                        <g id="g53">
                          <path
                            d="M 240,560 V 960"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path52" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-27" id="g56">
                        <g id="g55">
                          <path
                            d="M 720,560 V 480"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path54" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-28" id="g60">
                        <g id="g57">
                          <rect
                            x="160"
                            y="1120"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect56"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('karl-carl-lachmann') }"
                            @click="showPerson('karl-carl-lachmann')"
                          />
                        </g>
                        <g id="g59">
                          <g transform="scale(2)" id="g58">
                            <switch id="switch57">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 600px;
                                  margin-left: 81px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Karl [Carl] Lachmann</b><br />
                                      Berlin, 25.6.1886 – Berlin, 13.6.1942</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="200"
                                y="604"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text57">Karl [Carl] Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-52" id="g62">
                        <g id="g61">
                          <path
                            d="M 320,720 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path60" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-30" id="g66">
                        <g id="g63">
                          <rect
                            x="320"
                            y="640"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect62"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('edmund-alexis-lachmann') }"
                            @click="showPerson('edmund-alexis-lachmann')"
                            style="cursor: pointer;" />
                        </g>
                        <g id="g65">
                          <g transform="scale(2)" id="g64">
                            <switch id="switch63">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 360px;
                                  margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Edmund Alexis Lachmann</b><br />
                                      Berlin, 19.7.1920 – Paris, 1983</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="364"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text63">Edmund Alexis Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-51" id="g68">
                        <g id="g67">
                          <path
                            d="M 320,960 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path66" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-34" id="g72">
                        <g id="g69">
                          <rect
                            x="320"
                            y="880"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect68"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('paul-erwin-lachmann') }"
                            @click="showPerson('paul-erwin-lachmann')"
                          />
                        </g>
                        <g id="g71">
                          <g transform="scale(2)" id="g70">
                            <switch id="switch69">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 480px;
                                  margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Paul Erwin Lachmann</b><br />
                                      geb. Berlin, 20.9.1922</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="484"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text69">Paul Erwin Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-50" id="g74">
                        <g id="g73">
                          <path
                            d="M 320,1440 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path72" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-35" id="g78">
                        <g id="g75">
                          <rect
                            x="320"
                            y="1360"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect74"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('carlchen-lachmann') }"
                            @click="showPerson('carlchen-lachmann')"
                          />
                        </g>
                        <g id="g77">
                          <g transform="scale(2)" id="g76">
                            <switch id="switch75">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 720px;
                                  margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Carlchen Lachmann</b>
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="724"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text75">Carlchen Lachmann</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-36" id="g80">
                        <g id="g79">
                          <path
                            d="m 239.2,1280 v 80 l 0.8,80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path78" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-38" id="g82">
                        <g id="g81">
                          <path
                            d="m 521.5,160 h 80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path80" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-40" id="g86">
                        <g id="g83">
                          <rect
                            x="160"
                            y="1600"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect82"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('friedrich-lachmann') }"
                            @click="showPerson('friedrich-lachmann')"
                          />
                        </g>
                        <g id="g85">
                          <g transform="scale(2)" id="g84">
                            <switch id="switch83">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 840px;
                                  margin-left: 81px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Friedrich Lachmann</b><br />
                                      Berlin, 24.10.1888 – Schweiz, 25.3[4].1938</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="200"
                                y="844"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text83">Friedrich Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-41" id="g88">
                        <g id="g87">
                          <path
                            d="M 160,1200 H 80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path86" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-42" id="g90">
                        <g id="g89">
                          <path
                            d="M 160,1679.66 H 80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path88" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-43" id="g94">
                        <g id="g91">
                          <rect
                            x="800"
                            y="1600"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect90"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('olga-lucie-lachmann') }"
                            @click="showPerson('olga-lucie-lachmann')"
                          />
                        </g>
                        <g id="g93">
                          <g transform="scale(2)" id="g92">
                            <switch id="switch91">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 840px;
                                  margin-left: 401px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <div><b>Olga Lucie Lachmann</b><br />
                                      geb. Warburg<br />
                                      Hamburg, 17.11.1898 – 1965</div>
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="520"
                                y="844"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text91">Olga Lucie Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-44" id="g108">
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-45" id="g99">
                          <g id="g96">
                            <rect
                              x="674"
                              y="1600"
                              width="100"
                              height="160"
                              fill="none"
                              stroke="none"
                              pointer-events="all"
                              id="rect95"
                            />
                          </g>
                          <g id="g98">
                            <g transform="scale(2)" id="g97">
                              <switch id="switch96">
                                <foreignObject
                                  style="overflow: visible; text-align: left;"
                                  pointer-events="none"
                                  width="100%"
                                  height="100%"
                                  requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                  <div
                                    style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 48px; height: 1px; padding-top: 840px; margin-left: 338px;">
                                    <div
                                      style="box-sizing: border-box; font-size: 0; text-align: center; color: #000000; ">
                                      <div
                                        style="display: inline-block; font-size: 12px; font-family: Helvetica; color: light-dark(#000000, #ffffff); line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                                        <div
                                          style="line-height: 80%;">
                                          <br />
                                          <span
                                            style="font-family: Arial, Helvetica, sans-serif;">
                                            <font
                                              style="font-size: 10px; line-height: 80%;">29.4.1919<br />Hamburg</font>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </foreignObject>
                                <text
                                  x="362"
                                  y="844"
                                  fill="light-dark(#000000, #ffffff)"
                                  font-family="Helvetica"
                                  font-size="12px"
                                  text-anchor="middle"
                                  id="text96">29.4.191...</text>
                              </switch>
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-46" id="g105">
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-47" id="g102">
                            <g id="g101">
                              <circle
                                cx="730.5"
                                cy="1651"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse100"
                                r="13" />
                            </g>
                          </g>
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-48" id="g104">
                            <g id="g103">
                              <circle
                                cx="717.5"
                                cy="1651"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse102"
                                r="13" />
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-49" id="g107">
                          <g id="g106">
                            <path
                              d="m 680,1760.34 h 80"
                              fill="none"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-miterlimit="10"
                              pointer-events="stroke"
                              id="path105" />
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-53" id="g110">
                        <g id="g109">
                          <path
                            d="M 320,2000 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path108" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-54" id="g114">
                        <g id="g111">
                          <rect
                            x="320"
                            y="1920"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect110"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('grace-rose-aby-olga-lachmann') }"
                            @click="showPerson('grace-rose-aby-olga-lachmann')"
                          />
                        </g>
                        <g id="g113">
                          <g transform="scale(2)" id="g112">
                            <switch id="switch111">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1000px; margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Grace Rose Aby Olga Lachmann</b><br />
                                      geb. 's-Gravenhagen, 5.2.1920</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="1004"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text111">Grace Rose Aby Olga Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-56" id="g116">
                        <g id="g115">
                          <path
                            d="M 320,2240 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path114" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-57" id="g120">
                        <g id="g117">
                          <rect
                            x="320"
                            y="2160"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect116"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('edmund-george-lachmann') }"
                            @click="showPerson('edmund-george-lachmann')"
                          />
                        </g>
                        <g id="g119">
                          <g transform="scale(2)" id="g118">
                            <switch id="switch117">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1120px; margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Edmund George Lachmann</b><br />
                                      geb. 's-Gravenhagen, 17.3.1924</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="1124"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text117">Edmund George Lachmann...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-58" id="g122">
                        <g id="g121">
                          <path
                            d="m 720,1840 v -80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path120" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-59" id="g124">
                        <g id="g123">
                          <path
                            d="M 720,1840 H 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path122" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-60" id="g126">
                        <g id="g125">
                          <path
                            d="m 239.32,1840 1.08,201 -0.4,199"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path124" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-76" id="g128">
                        <g id="g127">
                          <path
                            d="M 160,2480 H 120 80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path126" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-61" id="g132">
                        <g id="g129">
                          <rect
                            x="160"
                            y="2400"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect128"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('dora-l-horowitz') }"
                            @click="showPerson('dora-l-horowitz')"
                          />
                        </g>
                        <g id="g131">
                          <g transform="scale(2)" id="g130">
                            <switch id="switch129">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1240px;
                                  margin-left: 81px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Dora L. Horowitz</b><br />
                                      geb. Lachmann<br />
                                      Berlin, 24.12.1893 – New York, 26.10.1939
                                      </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="200"
                                y="1244"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text129">Dora L. Horowitz...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-62" id="g136">
                        <g id="g133">
                          <rect
                            x="800"
                            y="2400"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect132"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('alfred-samuel-horwitz') }"
                            @click="showPerson('alfred-samuel-horwitz')"
                          />
                        </g>
                        <g id="g135">
                          <g transform="scale(2)" id="g134">
                            <switch id="switch133">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1240px; margin-left: 401px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <div>
                                      <span><b>Alfred Samuel Horwitz</b></span>
                                      <br />
                                      geb. Warburg<br />
                                      geb. Berlin, 126.4.1884</div>
                                    </div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="520"
                                y="1244"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text133">Alfred Samuel Horwitzgeb. Warburg...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-63" id="g150">
                        <g id="g137" />
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-64" id="g141">
                          <g
                            id="g138">
                            <rect
                              x="674"
                              y="2400"
                              width="100"
                              height="160"
                              fill="none"
                              stroke="none"
                              pointer-events="all"
                              id="rect137" />
                          </g>
                          <g id="g140">
                            <g transform="scale(2)" id="g139">
                              <switch id="switch138">
                                <foreignObject
                                  style="overflow: visible; text-align: left;"
                                  pointer-events="none"
                                  width="100%"
                                  height="100%"
                                  requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                  <div
                                    style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 48px; height: 1px; padding-top: 1240px; margin-left: 338px;">
                                    <div
                                      style="box-sizing: border-box; font-size: 0; text-align: center; color: #000000; ">
                                      <div
                                        style="display: inline-block; font-size: 12px; font-family: Helvetica; color: light-dark(#000000, #ffffff); line-height: 1.2; pointer-events: all; white-space: normal; word-wrap: normal; ">
                                        <div
                                          style="line-height: 80%;">
                                          <br />
                                          <span
                                            style="font-family: Calibri, sans-serif;">
                                            <font
                                              style="font-size: 10px; line-height: 80%;">29.4.1919<br />Hamburg</font>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </foreignObject>
                                <text
                                  x="362"
                                  y="1244"
                                  fill="light-dark(#000000, #ffffff)"
                                  font-family="Helvetica"
                                  font-size="12px"
                                  text-anchor="middle"
                                  id="text138">29.4.191...</text>
                              </switch>
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-65" id="g147">
                          <g id="g142" />
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-66" id="g144">
                            <g id="g143">
                              <circle
                                cx="730.5"
                                cy="2451"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse142"
                                r="13" />
                            </g>
                          </g>
                          <g data-cell-id="fKRA-seUdEVxIebNOzLq-67" id="g146">
                            <g id="g145">
                              <circle
                                cx="717.5"
                                cy="2451"
                                fill="none"
                                stroke="#000000"
                                stroke-width="2"
                                pointer-events="all"
                                id="ellipse144"
                                r="13" />
                            </g>
                          </g>
                        </g>
                        <g data-cell-id="fKRA-seUdEVxIebNOzLq-68" id="g149">
                          <g id="g148">
                            <path
                              d="m 680,2560.34 h 80"
                              fill="none"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-miterlimit="10"
                              pointer-events="stroke"
                              id="path147" />
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-69" id="g152">
                        <g id="g151">
                          <path
                            d="M 320,2800 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path150" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-70" id="g156">
                        <g id="g153">
                          <rect
                            x="320"
                            y="2720"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect152"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('gerda-ghislaine-guillibert-de-la-lauziere') }"
                            @click="showPerson('gerda-ghislaine-guillibert-de-la-lauziere')"
                          />
                        </g>
                        <g id="g155">
                          <g transform="scale(2)" id="g154">
                            <switch id="switch153">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1400px;
                                  margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Gerda Ghislaine Guillibert de la Lauzière</b><br />
                                      geb. Horowitz<br />
                                      geb. Berlin, 1.7.1916</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="1404"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text153">Gerda Ghislaine Guillibert de la Lauzièr...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-71" id="g158">
                        <g id="g157">
                          <path
                            d="M 320,3040 H 280 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path156" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-72" id="g162">
                        <g id="g159">
                          <rect
                            x="320"
                            y="2960"
                            width="480"
                            height="160"
                            rx="24"
                            ry="24"
                            fill="#ffffff"
                            stroke="#000000"
                            stroke-width="2"
                            pointer-events="all"
                            id="rect158"
                            class="person-rect"
                            :class="{ selected: isSelectedPerson('olga-sophie-fread') }"
                            @click="showPerson('olga-sophie-fread')"
                          />
                        </g>
                        <g id="g161">
                          <g transform="scale(2)" id="g160">
                            <switch id="switch159">
                              <foreignObject
                                style="overflow: visible; text-align: left;"
                                pointer-events="none"
                                width="100%"
                                height="100%"
                                requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
                                <div
                                  style="display: flex;
                                  align-items: unsafe center;
                                  justify-content: unsafe center;
                                  width: 238px;
                                  height: 1px;
                                  padding-top: 1520px;
                                  margin-left: 161px;">
                                  <div
                                    style="box-sizing: border-box;
                                    font-size: 0;
                                    text-align: center;
                                    color: #000000; ">
                                    <div
                                      style="display: inline-block;
                                      font-size: 12px;
                                      font-family: Helvetica;
                                      color: light-dark(#000000, #ffffff);
                                      line-height: 1.2;
                                      pointer-events: none;
                                      white-space: normal;
                                      word-wrap: normal; ">
                                      <b>Olga Sophie Fread</b><br />
                                      geb. Horowitz<br />
                                      Berlin 14.2.1922 – Juni 1966</div>
                                  </div>
                                </div>
                              </foreignObject>
                              <text
                                x="280"
                                y="1524"
                                fill="light-dark(#000000, #ffffff)"
                                font-family="Helvetica"
                                font-size="12px"
                                text-anchor="middle"
                                id="text159">Olga Sophie Fread...</text>
                            </switch>
                          </g>
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-73" id="g164">
                        <g id="g163">
                          <path
                            d="m 720,2640 v -80"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path162" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-74" id="g166">
                        <g id="g165">
                          <path
                            d="M 720,2640 H 240"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path164" />
                        </g>
                      </g>
                      <g data-cell-id="fKRA-seUdEVxIebNOzLq-75" id="g168">
                        <g id="g167">
                          <path
                            d="m 239.32,2640 1.08,201 -0.4,199"
                            fill="none"
                            stroke="#000000"
                            stroke-width="2"
                            stroke-miterlimit="10"
                            pointer-events="stroke"
                            id="path166" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 md5 lg5>
          <v-card flat class="trbg genealogie-card">
            <div class="genealogy-infos">
              <div v-if="selectedPerson">
                <h2>{{ selectedPerson.name_der_person }}</h2>
                <div v-if="selectedPerson.bild" class="person-image mb-3">
                  <img :src="selectedPerson.bild" :alt="selectedPerson.name_der_person" style="max-width: 100%; height: auto;">
                </div>
                <div class="person-info">
                  <p v-if="selectedPerson.geburtsname"><strong>{{ translate['Geburtsname'][lang] }}:</strong> {{ selectedPerson.geburtsname }}</p>
                  <p v-if="selectedPerson.lebensdaten"><strong>{{ translate['Lebensdaten'][lang] }}:</strong> {{ selectedPerson.lebensdaten }}</p>
                  <div v-if="selectedPerson.biografische_informationen" class="biographical-info">
                    <h4>{{ translate['Biografische Informationen'][lang] }}:</h4>
                    <div v-html="selectedPerson.biografische_informationen"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="genealogie-hint">{{ translate['genealogie-hint'][lang] }}</p>
              </div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Genealogie',
  data () {
    return {
      selectedPerson: null
    }
  },
  methods: {
    ...mapActions(['getGenealogyPersons']),
    showPerson (slug) {
      const person = this.genealogyPersons.find(p => p.slug === slug)
      if (person) {
        this.selectedPerson = person
      } else {
        this.selectedPerson = null
      }
    },
    isSelectedPerson (slug) {
      return this.selectedPerson && this.selectedPerson.slug === slug
    }
  },
  created () {
    this.getGenealogyPersons()
  },
  computed: {
    ...mapGetters([
      'genealogyPersons',
      'translate',
      'lang'
    ])
  }
}
</script>
<style scoped>
.text-center {
  text-align: center;
}
.application .v-content h2 {
  margin-top: 0;
  font-size: 1.5rem;
}
.genealogie-card {
  width: 100%;
  padding: 1rem 1.4rem;
  /* border: 1px solid #000; */
}
#genealogie-svg {
  width: 100%;
}
.person-rect {
  cursor: pointer;
}
.person-rect:hover {
  fill: rgba(0, 0, 0, 0.1);
}
.person-rect.selected {
  fill: rgba(105, 40, 255, 0.2);
  stroke: #6928ff;
  stroke-width: 2px;
}
.genealogy-infos {
  position: relative;
}
@media (min-width: 960px) {
  .genealogy-infos {
    position: fixed;
    top: 88px;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
  }
}
@media (min-width: 1025px) {
  .genealogy-infos {
    top: 40px;
  }
}
.genealogie-hint {
  color: #666;
  font-style: italic;
  text-align: center;
  margin-top: 1rem;
  background-color: #f3f3f3;
  padding: 0.5rem;
  border-radius: 6px;
}
.genealogie-hint:hover {
  background-color: #e9e9e9;
}
.person-image {
  text-align: center;
}
.person-image img {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  max-height: 560px;
}
.person-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}
.person-info p {
  margin-bottom: 1rem;
}
.biographical-info {
  margin-top: 1rem;
}
.biographical-info h4 {
  color: #555;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Genealogie.vue